<script lang="ts">
    
    import { Link } from "svelte-navigator";
    import { Badge, Button, Col, Container, Icon, Row, Table } from "sveltestrap";
    import AppWrapper from "../components/AppWrapper.svelte";
    import DateString from "../components/DateString.svelte";
    import FormName from "../components/FormName.svelte";
    import SearchForm from "../components/Historic/SearchForm.svelte";
    import UserName from "../components/UserName.svelte";
    import { SERVICE_URL } from "../evironment";
    import type { FormInstance, HistoricSearchParams } from "../global";
    import { Query } from "../Model/Query";    
    import { instancePdfFactory, instancesService } from "../services";

    const limit = 20;

    let offset = 0;
    let hasMore = true;
    let isFetching = false;
    let instancesTotal = 0;
    let instances: FormInstance[] = [];
    let currentSearchParams: HistoricSearchParams;
    let extraColumns: any[] = [];

    getInstances();
    
    async function getInstances(): Promise<void> {
        if (isFetching) {
            return;
        }
        try {
            isFetching = true;

            const query = new Query(offset, limit);

            if (currentSearchParams) {
                if (currentSearchParams.formId) {
                    query.addFilter('form_id', [currentSearchParams.formId]);
                }

                if (currentSearchParams.userId) {
                    query.addFilter('user_id', [currentSearchParams.userId]);
                }

                if (currentSearchParams.formText) {
                    query.addFilter('form_text', [currentSearchParams.formText]);
                }

                if (currentSearchParams.completedFrom) {
                    query.addFilter('completed_from', [currentSearchParams.completedFrom]);
                }

                if (currentSearchParams.completedUntil) {
                    query.addFilter('completed_until', [currentSearchParams.completedUntil]);
                }

                if (currentSearchParams.isDownloaded !== undefined) {
                    query.addFilter('is_downloaded', [currentSearchParams.isDownloaded ? '1' : '0']);
                }
            }

            const results = await instancesService.getInstances(query);
            const page = results.results;

            instancesTotal = results.numResults;

            if (page.length === 0) {
                hasMore = false;
                return;
            }

            instances = [...instances, ...page];

        } catch (error) {
            console.error(error);
        } finally {
            isFetching = false
        }
    }

    function getMore(): void {
        if (isFetching) {
            return;
        }
        offset += limit;
        getInstances();
    }

    function onSearch({ detail: searchParams }: CustomEvent<HistoricSearchParams>): void {
        offset = 0;
        currentSearchParams = searchParams;
        instances = [];
        getInstances();
    }

    async function downloadPdf(instance: FormInstance): Promise<void> {
        const blob = await instancePdfFactory.createPdf(instance);
        console.log(blob);
        
        const anchor = document.createElement('a') as HTMLAnchorElement;
        anchor.download = 'Formulario.pdf';
        anchor.href = URL.createObjectURL(blob);
        anchor.addEventListener('click', () => {
            setTimeout(() => URL.revokeObjectURL(anchor.href));
        });
    }

</script>

<style lang="scss">

    .member {

        &:nth-child(2) ~ .member {
            
            &::before {
                content: ', ';
            }

        }

    }

</style>

<AppWrapper>
    <Container fluid>
        <Row>
            <Col xs="12">
                <h3>Historial</h3>
            </Col>
        </Row>
        <Row>
            <Col xs="12" class="mb-4">
                <SearchForm on:search={onSearch} />
            </Col>
            <Col xs="12" class="mb-4 text-end">
                <p>Número total de resultados: {instancesTotal}</p>
            </Col>
        </Row>
        <Row>
            <Col xs="12">
                <Table>
                    <thead>
                        <tr>
                            <th>Formulario</th>
                            <th>Miembros</th>
                            <th>Estado</th>
                            <th>Fecha creado</th>
                            <th>Fecha finalizado</th>
                            <th>Descargado</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each instances as instance}
                        <tr>
                            <td>
                                <Link to="/respuestas/{instance.id}">
                                    <FormName formId={instance.formId} />
                                </Link>
                            </td>
                            <td>
                                <span class="member">({instance.members.length})</span>
                                {#each instance.members as member}
                                <span class="member"><UserName userId={member.userId} /></span>
                                {/each}
                            </td>
                            <td>
                                {#if instance.isFinished}
                                    <Badge color="success">Finalizado</Badge>
                                {:else}
                                    <Badge color="warning">Pendiente</Badge>
                                {/if}
                            </td>
                            <td>
                                <DateString date={instance.dateCreated} />
                            </td>
                            <td>
                                <DateString date={instance.dateCompleted} />
                            </td>
                            <td>
                                {#if instance.isDownloaded}
                                    <Badge color="success">Descargado</Badge>
                                {/if}
                            </td>
                            <td>
                                <a href="{SERVICE_URL}/instance/{instance.id}/pdf?markAsDownloaded=1" target="_blank">
                                    <Icon name="download" />
                                </a>
                                <!-- <Button type="button" color="light" size="sm" on:click={() => downloadPdf(instance)}>
                                    <Icon name="download" />
                                </Button>-->
                            </td>
                        </tr>
                        {/each}
                    </tbody>
                </Table>
            </Col>
        </Row>
        {#if hasMore}
        <Row>
            <Col xs="12" class="text-center">
                <Button type="button" color="primary" on:click={getMore} disabled={isFetching}>
                    {#if isFetching}
                        Descargando...
                    {:else}
                        Ver más
                    {/if}
                </Button>
            </Col>
        </Row>
        {/if}
    </Container>
</AppWrapper>
